import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'booleanYesNoEmptyTranslate',
  standalone: true
})
export class BooleanYesNoEmptyTranslate implements PipeTransform {
  translateService = inject(TranslateService);

  constructor() { }
  transform(value: boolean): string {
    if (value === null || value === undefined) {
      return "";
    }

    return value ? this.translateService.instant('ml_143931') : this.translateService.instant('ml_143932');
  }
}
